import { extendTheme } from '@chakra-ui/react';
const theme = extendTheme({
	shadows: {
		outline: '0 0 0 3px rgba(236, 201, 75, 0.4) !important',
	},
});

export default theme;
